import { createFileRoute } from '@tanstack/react-router';

import { DuplicateActivityForm } from '@/areas/manufacturing-templates/Activities/ActivityCreation/DuplicateActivityForm';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { PageLayout } from '@/shared/ui/PageLayout';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/activities/$activityId/duplicate')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <PageLayout layout="full-width">
            <DuplicateActivityForm activityId={pathParams.activityId} />
        </PageLayout>
    );
}
